/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */


/**
 * ForgeApiConfig
 * The API http call parameters for Forge.
 */
export class ForgeApiConfig {

  /**
   * Get the Configuration for AXIOS
   * @returns {{baseURL: string; headers: {"Ocp-Apim-Subscription-Key": string; "Content-Type": string}}}
   */
  getConfig() {
    let envVariables = window.envVariables;
    return {
      headers : {
        'Ocp-Apim-Subscription-Key' : envVariables.OCP_APIM_SUBSCRIPTION_KEY,
        'fc-kong-api-key' : envVariables.FC_KONG_API_KEY,
        'Content-Type' : 'application/json',
        'Accept' : 'application/json'
      }
    }
  }

  /**
   * Get the Configuration for Cloud Connector AXIOS
   * @returns {{baseURL: string; headers: {"Ocp-Apim-Subscription-Key": string; "Content-Type": string}}}
   */
  getCloudConnectorConfig(){
    let envVariables = window.envVariables;
    return {
      headers : {
        'Ocp-Apim-Subscription-Key' : envVariables.OCP_APIM_SUBSCRIPTION_KEY_CLOUDCONNECTOR,
        'Content-Type' : 'application/json'
      }
    }
  }

  /**
   * Get the Configuration for SimplyConnect AXIOS
   * @returns {{baseURL: string; headers: {"OrganizationId": string; "Content-Type": string}}}
   */
  getSimplyConnectConfig()
  {
    return {
        headers : {
            'OrganizationId' : '0',
            'Content-Type' : 'application/json'
        }
    }
  }


 /**
   * Get the Configuration for AXIOS EPM client 
   * @returns {{baseURL: string; headers: {"fc-kong-api-key": string; "Content-Type": string;"Authorization": string}}}
   */
  getEPMConfig(access_token : string) {
    let envVariables = window.envVariables;
    return {
      headers : {        
        'fc-kong-api-key':envVariables.FCP_KONG_API_KEY,
        'Content-Type' : 'application/json',
        'Accept' : 'application/json',
        'Authorization': `Bearer ${access_token}`
      }
    }
  }
}

export default new ForgeApiConfig();
